import StatusChip from './StatusChip';
import getStatusColor from './statusColor.utils';

export * from './StatusChip.types';
export { getStatusColor, StatusChip };
export default StatusChip;
